"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientContractsPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const helpers_1 = require("../../utils/helpers");
const alert_box_1 = require("../../widgets/alert_box");
const client_contract_table_1 = require("../components/contract/client_contract_table");
let updates;
function renderUpdateInfos() {
    if (updates) {
        let alreadyBooked = updates.total_in_contracts - updates.total_bookable;
        if (alreadyBooked > 0) {
            return (0, mithril_1.default)("div", { style: "padding: 0 1.0em" }, (0, alert_box_1.alertBox)({
                content: mithril_1.default.trust(`Il vous reste <strong>${(0, helpers_1.minutesToUnit)(updates.total_bookable)} points</strong> réservables sur un total de ` +
                    `<strong>${(0, helpers_1.minutesToUnit)(updates.total_in_contracts)} points</strong>, car ` +
                    `<strong>${(0, helpers_1.minutesToUnit)(alreadyBooked)} points</strong> sont déjà reservés.`),
                level: "info"
            }));
        }
    }
    return undefined;
}
exports.ClientContractsPage = {
    oncreate() {
        app_1.App.get("/me/updates").then((x) => {
            updates = x;
        });
    },
    view() {
        return (0, mithril_1.default)("div", renderUpdateInfos(), (0, mithril_1.default)(client_contract_table_1.ClientContractTable));
    }
};
